import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class BlogArea extends Component {
  render() {
    return (
      <section className='section cm-blogs bg-light-gray'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 text-center'>
              <h2 className='section-heading h1 text-dark mb-15'>From Our Blog</h2>
            </div>
            <div className='col-lg-4 col-md-6'>
              <div className='blog-item card border-0 mt-30'>
                <Link className='initiate-scripts' to={'/blog-details'}>
                  <img className='card-img-top' src={process.env.PUBLIC_URL + '/assets/images/blogs/01.jpg'} alt='' loading="lazy" />
                </Link>
                <div className='card-body'>
                  <div className='blog-meta small'>
                    <span className='font-w-600 mr-3'>
                      <span className='fas fa-calendar-alt text-primary mr-2' />
                      January 05, 2024
                    </span>
                    <span className='font-w-600'>
                      <span className='fas fa-comment-dots text-primary mr-2' />
                      Comment
                    </span>
                  </div>
                  <Link to={'/blog-details'} className='h4 mt-10 font-w-400 text-dark line-h-1-5 initiate-scripts'>
                    Is it worth fixing a cracked iPhone screen?
                  </Link>
                  <Link to={'/blog-details'} className='text-dark font-w-600 text-uppercase mt-15 initiate-scripts'>
                    Read More <span className='fas fa-long-arrow-alt-right text-primary' />
                  </Link>
                </div>
              </div>
            </div>
            <div className='col-lg-4 col-md-6'>
              <div className='blog-item card border-0 mt-30'>
                <Link className='initiate-scripts' to={'/blog-details1'}>
                  <img className='card-img-top' src={process.env.PUBLIC_URL + '/assets/images/blogs/02.jpg'} alt='' loading="lazy" />
                </Link>
                <div className='card-body'>
                  <div className='blog-meta small'>
                    <span className='font-w-600 mr-3'>
                      <span className='fas fa-calendar-alt text-primary mr-2' />
                      April 05, 2024
                    </span>
                    <span className='font-w-600'>
                      <span className='fas fa-comment-dots text-primary mr-2' />
                      Comment
                    </span>
                  </div>
                  <Link to={'/blog-details1'} className='h4 mt-10 font-w-400 text-dark line-h-1-5 initiate-scripts'>
                    How do I get data from a broken iPhone screen?
                  </Link>
                  <Link to={'/blog-details1'} className='text-dark font-w-600 text-uppercase mt-15 initiate-scripts'>
                    Read More <span className='fas fa-long-arrow-alt-right text-primary' />
                  </Link>
                </div>
              </div>
            </div>
            <div className='col-lg-4 col-md-6'>
              <div className='blog-item card border-0 mt-30'>
                <Link className='initiate-scripts' to={'/blog-details2'}>
                  <img className='card-img-top' src={process.env.PUBLIC_URL + '/assets/images/blogs/03.jpg'} alt='' loading="lazy" />
                </Link>
                <div className='card-body'>
                  <div className='blog-meta small'>
                    <span className='font-w-600 mr-3'>
                      <span className='fas fa-calendar-alt text-primary mr-2' />
                      October 07, 2024
                    </span>
                    <span className='font-w-600'>
                      <span className='fas fa-comment-dots text-primary mr-2' />
                      Comment
                    </span>
                  </div>
                  <Link to={'/blog-details2'} className='h4 mt-10 font-w-400 text-dark line-h-1-5 initiate-scripts'>
                    Can you still use an iPhone with a cracked screen?
                  </Link>
                  <Link to={'/blog-details2'} className='text-dark font-w-600 text-uppercase mt-15 initiate-scripts'>
                    Read More <span className='fas fa-long-arrow-alt-right text-primary' />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default BlogArea;
